<div class="four_zero_four_page">
    <div class="page_wrap_sections">
        <div class="left_side_secitons">
            <div class="circle_sections">
                <h2>404</h2>
                <p>Page Not Found</p>
            </div>
        </div>
        <div class="right_side_secitons" style="padding: 50px 0 0 0;">
            <!-- <h2>Oh no!</h2> -->
            <h2 style="font-size: 30px;">ページが見つかりませんでした。</h2>
            <p>お探しのページは一時的にアクセスできない状態にあるか、移動または削除された可能性があります。</p>
            <button [routerLink]="['']">ホームに戻る</button> 
        </div>
    </div>
</div>
